// AWS Amplify Configuration for Cognito Authentication
// Matches ecommerce-ui configuration

const awsExports = {
  Auth: {
    Cognito: {
      region: 'ap-southeast-1',
      userPoolId: 'ap-southeast-1_whljwIwNs',
      userPoolClientId: '6oamh8am3m4km93s8bcss7ua9p',
    },
  },
};

export default awsExports;
